import React from "react";

// reactstrap components

const AdminNavbar = () => {
  return <></>;
};

export default AdminNavbar;
